import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, message, Table, Tag, Form } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import './Page2.css';
import createRowData from "../components/createRowData";
import { SearchOutlined } from '@ant-design/icons';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useDemoData } from '@mui/x-data-grid-generator';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { DatePicker, Space, Button } from 'antd';
import React, { useState } from 'react';
import axios from 'axios';
import { makeStyles } from "@mui/material/styles";
import { Backdrop } from '@mui/material';


// import axios from 'axios';

const dateFormat = 'YYYY/MM/DD';
const { Column, ColumnGroup } = Table;


const Notifications: React.FC = (props: any) => {

  const useStyles = makeStyles((theme) => ({
      backdrop: {
        background: "black",
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
      },
  }));

  const { data } = useDemoData({
    dataSet: 'Commodity',
    rowLength: 100,
    maxColumns: 6,
  });

  const { name } = useParams<{ name: string; }>();

  const columns = [

    { field: 'id', headerName: 'ID', width: 170 },
    { field: 'Date', headerName: 'DATE', width: 170 },
    { field: 'USERID', headerName: 'USER ID', width: 170 },
    { field: 'Text', headerName: 'Details', width: 170 },
    { field: 'Status', headerName: 'Status', width: 170 },
    { field: 'Type', headerName: 'Type', width: 170 },
  ];

  const [data1, SetData] = useState([]);

  const [open, setOpen] = useState(true);

  const handleBackDropClose = () => {
    setOpen(false);
  };
  const classes = useStyles();

  useIonViewDidEnter(() => {

    axios.get('https://dev.northroom.co.za/api/bizprop/users/fetch/notifications/all')
      .then(function (response) {
        // handle success
       // console.log(response.data);
        SetData(response.data);
        handleBackDropClose();
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
      });


  });

  return (
    <IonPage>
      <Backdrop
        className={classes.backdrop}
        open={open}
        transitionDuration={1500}
      ></Backdrop>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonRow>
            <PageHeader
              className="site-page-header"
              onBack={() => { props.history.goBack() }}
              title="Notifications"
            />
          </IonRow>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen >
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Space direction="vertical">
          <IonGrid>
            <IonRow>
              <IonCol size="11" style={{ paddingLeft: "2vw", paddingRight: "5vw" }}>
                <IonCard>
                  <IonCardHeader>

                  </IonCardHeader>

                  <IonCardContent>

                    <div style={{ height: 400, width: '80vw', paddingRight: "7.5vw" }}>
                      <DataGrid
                        rows={data1}
                        columns={columns}
                        components={{
                          Toolbar: GridToolbar,
                        }}
                        filterModel={{
                          items: [
                            { columnField: 'USERID', operatorValue: 'contains', value: '' },
                          ],
                        }}
                      />
                    </div>
                  
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </Space>
      </IonContent>
    </IonPage>


  );
};

export default Notifications;